import React, { createContext, useState, useContext } from 'react';
import axios from 'axios';
import { API_NETWORK_ERROR, localStorageKeys } from '../../utils/constants';
import {
  onLoadInformationAPI,
  onPhoneVerificationAPI,
  reportUiBugApi,
} from './../api-services/Onloadinfo';
import { onManageDeliveriesAPI } from './../api-services/ManageDeliveries.service';
import { getUrlPath } from '../../utils/getUrls';

export const GlobalStateDataContext = createContext();
const GlobalStateDataProvider = ({ children }) => {
  const { REFRESH_TOKEN, TOKEN } = localStorageKeys;
  const checkUrl = getUrlPath() === '/';
  const hasTokens = !!(localStorage.getItem(REFRESH_TOKEN) && localStorage.getItem(TOKEN));
  const [isLoggedIn, setIsLoggedIn] = useState(hasTokens);
  const [showCongrat, setShowCongrat] = useState(false);
  const [showSignup, setShowSignup] = useState(false);
  const [showPricePlan, setShowPricePlan] = useState(false);
  const [selectedPricePLan, setSelectedPricePLan] = useState('basic');
  const [selectedMenuTab, setSelectedMenuTab] = useState(checkUrl ? 'action' : '');

  const [newPendingOrder, setNewPendingOrder] = useState([]);
  const [preparingOrder, setPreparingOrder] = useState([]);
  const [orderReadyForPickup, setOrderReadyForPickup] = useState([]);
  const [scheduledOrder, setScheduledOrder] = useState([]);
  const [openOrderAlert, setOpenOrderAlert] = useState(false);
  const [pageReloaded, setPageReloaded] = useState(false);

  const [openUpdateTimeDialog, setOpenUpdateTimeDialog] = useState(false);

  const [openCancelOrderDialog, setOpenCancelOrderDialog] = useState(false);

  const [openSnackBar, setOpenSnackBar] = useState({
    open: false,
    vertical: 'top',
    horizontal: 'right',
    snakBarMessage: '',
    warning: false,
  });

  const [allOrders, setAllOrders] = useState([]);

  const [inHouseDeliveryOrders, setInHouseDeliveryOrders] = useState([]);

  const [zipcodeInfo, setZipcodeInfo] = useState({
    latitude: null,
    longitude: null,
    managing_branch_name: null,
    googlePlaceId: null,
    arrayOfNeighbourGooglePlaceId: [],
    arrayOfNeighbourZipcodes: [],
  });

  const [onLoadInfoResponse, setOnLoadInfoResponse] = useState({
    loading: false,
    success: null,
    message: null,
    data: null,
  });

  const [onManageDeliveriesResponse, setOnManageDeliveriesResponse] = useState({
    loading: false,
    success: null,
    message: null,
    data: null,
  });

  const [onPhoneVerifyResponse, setOnPhoneVerifyResponse] = useState({
    loading: false,
    success: null,
    message: null,
    data: null,
  });

  const [reportUiBugResponse, setReportUiBugResponse] = useState({
    isloading: false,
    data: null,
    success: null,
    message: null,
  });

  const OnLoadInformation = async (payload) => {
    try {
      setOnLoadInfoResponse({
        loading: true,
        success: null,
        message: null,
        data: null,
      });

      const data = await onLoadInformationAPI(payload);

      if (data.hasError) {
        setOnLoadInfoResponse({
          loading: false,
          data: null,
          success: !data.hasError,
          message: data.message,
        });
        return;
      }

      if (data.data?.success) {
        setOnLoadInfoResponse({
          loading: false,
          data: data,
          success: data.data?.success,
          message: data.data?.message,
        });
      } else {
        setOnLoadInfoResponse({
          loading: false,
          data: data,
          success: data.data?.success,
          // message: data.data?.errors[0]?.CustomMessage || data.data?.CustomMessage,
          message: data.data?.CustomMessage || 'Backend Validation errors',
        });
      }
      return;
    } catch (error) {
      console.log('---Catch black onSignup', error);
      setOnLoadInfoResponse({ loading: false, data: null, success: false, message: error });
    }
  };

  const OnKitchenManageDeliveries = async (payload) => {
    // {
    //     "branchName": "6244dummybranchname",
    //     "kitchenName": "9301postmankitchen"
    // }

    try {
      setOnManageDeliveriesResponse({
        loading: true,
        success: null,
        message: null,
        data: {},
      });

      const data = await onManageDeliveriesAPI(payload);

      if (data.hasError) {
        setOnManageDeliveriesResponse({
          loading: false,
          data: {},
          success: !data.hasError,
          message: data.message,
        });
        return;
      }

      if (data.data?.success) {
        setOnManageDeliveriesResponse({
          loading: false,
          data: data.data,
          success: data.data?.success,
          message: data.data?.message,
        });
      } else {
        setOnManageDeliveriesResponse({
          loading: false,
          data: data,
          success: data.data?.success,
          // message: data.data?.errors[0]?.CustomMessage || data.data?.CustomMessage,
          message: data.data?.CustomMessage || 'Backend Validation errors',
        });
      }
      return;
    } catch (error) {
      console.log('---Catch black  OnKitchenManageDeliveries', error);
      setOnManageDeliveriesResponse({ loading: false, data: {}, success: false, message: error });
    }
  };

  const OnPhoneVerify = async (payload) => {
    try {
      setOnPhoneVerifyResponse({
        loading: true,
        success: null,
        message: null,
        data: null,
      });

      const data = await onPhoneVerificationAPI(payload);
      if (data.hasError) {
        setOnPhoneVerifyResponse({
          loading: false,
          data: null,
          success: !data.hasError,
          message: data?.message?.CustomMessage || data?.data?.CustomMessage,
        });
        return;
      }

      if (data.data?.success) {
        setOnPhoneVerifyResponse({
          loading: false,
          data: data,
          success: data.data?.success,
          message: data?.data?.CustomMessage,
        });
        return data;
      } else {
        setOnPhoneVerifyResponse({
          loading: false,
          data: data,
          success: data.data?.success,
          message: data.data?.CustomMessage,
        });
      }
      return data;
    } catch (error) {
      console.log('---Catch black OnPhoneVerify', error);
      setOnPhoneVerifyResponse({ loading: false, data: null, success: false, message: error });
    }
  };

  const onReportUiBugCustomer = async (payload) => {
    try {
      setReportUiBugResponse({
        isloading: true,
        data: null,
        success: null,
        message: null,
      });
      const response = await reportUiBugApi(payload);
      if (response.hasError) {
        await setReportUiBugResponse({
          isloading: false,
          data: null,
          success: !response.hasError,
          message:
            response.data?.ErrorMessage || response.data?.customMessage || response.data?.message,
        });
        return;
      }

      if (response?.data?.success) {
        setReportUiBugResponse({
          isloading: false,
          data: response.data,
          success: response.data.success,
          message:
            response.data?.ErrorMessage || response.data?.customMessage || response.data?.message,
        });

        return response;
      }

      if (response.data?.success === false) {
        setReportUiBugResponse({
          isloading: false,
          data: response.data,
          success: response.data.success,
          message:
            response.data?.ErrorMessage || response.data?.customMessage || response.data?.message,
        });

        return response;
      }
    } catch (error) {
      console.log('catch block for onReportUiBugCustomer', error);
      setReportUiBugResponse({
        data: null,
        isLoading: false,
        message: error,
        success: false,
      });
    }
  };

  return (
    <GlobalStateDataContext.Provider
      value={{
        isLoggedIn,
        setIsLoggedIn,
        zipcodeInfo,
        setZipcodeInfo,
        OnLoadInformation,
        onLoadInfoResponse,
        setOnLoadInfoResponse,
        showCongrat,
        setShowCongrat,
        showSignup,
        setShowSignup,
        showPricePlan,
        setShowPricePlan,
        selectedPricePLan,
        setSelectedPricePLan,
        OnKitchenManageDeliveries,
        onManageDeliveriesResponse,
        setOnManageDeliveriesResponse,
        selectedMenuTab,
        setSelectedMenuTab,
        newPendingOrder,
        setNewPendingOrder,
        preparingOrder,
        setPreparingOrder,
        orderReadyForPickup,
        setOrderReadyForPickup,
        scheduledOrder,
        setScheduledOrder,
        openOrderAlert,
        setOpenOrderAlert,
        pageReloaded,
        setPageReloaded,
        allOrders,
        setAllOrders,
        inHouseDeliveryOrders,
        setInHouseDeliveryOrders,
        openUpdateTimeDialog,
        setOpenUpdateTimeDialog,
        openSnackBar,
        setOpenSnackBar,
        openCancelOrderDialog,
        setOpenCancelOrderDialog,
        OnPhoneVerify,
        setOnPhoneVerifyResponse,
        onPhoneVerifyResponse,
        onReportUiBugCustomer,
        reportUiBugResponse,
        setReportUiBugResponse,
      }}
    >
      {children}
    </GlobalStateDataContext.Provider>
  );
};

export default GlobalStateDataProvider;
